// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3_uqH","productName":"Table_productName__1Xr_m"};